import AuthCheck from "../components/authenticate/AuthCheck";

const CustomerEngagement = () =>
    import("../components/dashboard/reports/CustomerEngagement");
const Consultantworkload = () =>
    import("../components/dashboard/reports/Consultantworkload");
const QcentrisUnitTurnover = () =>
    import("../components/dashboard/reports/QcentrisUnitTurnover");
const QcentrisCountryTurnover = () =>
    import("../components/dashboard/reports/QcentrisCountryTurnover");
const CustomerTurnover = () =>
    import("../components/dashboard/reports/CustomerTurnover");
const BenchOverview = () =>
    import("../components/dashboard/reports/BenchOverview");
const Login = () => import("./../components/authenticate/Login");
const Home = () => import("./../components/Home");
const PageNotFound = () => import("../components/common/PageNotFound");
const Forecast = () => import("../components/dashboard/Forecast");
const Reports = () => import("../components/dashboard/Reports");
const QtimeReports = () => import("../components/dashboard/QtimeReports");
const Qtime = () => import("../components/dashboard/Qtime");
const LeaveRequest = () => import("../components/dashboard/LeaveRequest");
const SicknessRequest = () => import("../components/dashboard/SicknessRequest");
const QtimeActivity = () =>
    import("../components/dashboard/qtimeReports/QtimeActivity");
const PersonalOverview = () =>
    import("../components/dashboard/qtimeReports/PersonalOverview");
const FinanceReport = () =>
    import("../components/dashboard/qtimeReports/FinanceReport");
const LocationOverview = () =>
    import("../components/dashboard/qtimeReports/LocationOverview");
const TeamOverview = () =>
    import("../components/dashboard/qtimeReports/TeamOverview");
const ReleaseEmployeeMonthData = () =>
    import("../components/dashboard/qtimeReports/ReleaseEmployeeMonthData");
const ExportEmployeesData = () =>
    import("../components/dashboard/qtimeReports/ExportEmployees");
const ReleaseOverview = () =>
    import("../components/dashboard/qtimeReports/ReleaseOverview");
const ReleaseOverviewManager = () =>
    import("../components/dashboard/qtimeReports/ReleaseOverviewManager");
const EmployeeOverview = () =>
    import("../components/dashboard/qtimeReports/EmployeeOverview");
const VacationReportOverview = () =>
    import("../components/dashboard/qtimeReports/VacationReportOverview");
const EmployeeSummary = () =>
    import("../components/dashboard/qtimeReports/TimeOverview");
const DeliveryManagerEmployeeOverview = () =>
    import("../components/dashboard/qtimeReports/DelManagerEmployeeOverview");
const DeliveryManagerInternalOverview = () =>
    import("../components/dashboard/qtimeReports/DelManagerInternalOverview");
const DeliveryManagerExternalOverview = () =>
    import("../components/dashboard/qtimeReports/DelManagerExternalOverview");
const DirectManagerOverview = () =>
    import("../components/dashboard/qtimeReports/DirectManagerDashboardOverview");
    
export const routes = [
    {
        
        name: "home",
        path: "/",
        component: Home,
        redirect: { name: window.location.hostname.includes('forecast') ? "forecast" : "qtime" },
        children: [
            {
                name: "forecast",
                path: "forecast",
                component: Forecast,
                meta: {
                    title: 'QForecast'
                }
            },
            {
                name: "reports",
                path: "reports",
                component: Reports,
                redirect: {name: "bench-overview"},
                children: [
                    {
                        name: "bench-overview",
                        path: "bench",
                        component: BenchOverview,
                        meta: {
                            parent: "reports",
                            title: 'Report'
                        }
                    },
                    {
                        name: "customer-turnover",
                        path: "customer-turnover",
                        component: CustomerTurnover,
                        meta: {
                            parent: "reports",
                            title: 'Report'
                        }
                    },
                    {
                        name: "customer-engagement",
                        path: "customer-engagement",
                        component: CustomerEngagement,
                        meta: {
                            parent: "reports",
                            title: 'Report'
                        }
                    },
                    {
                        name: "consultant-workload",
                        path: "consultant-workload",
                        component: Consultantworkload,
                        meta: {
                            parent: "reports",
                            title: 'Report'
                        }
                    },
                    {
                        name: "qcentris-unit-turnover",
                        path: "qcentris-unit-turnover",
                        component: QcentrisUnitTurnover,
                        meta: {
                            parent: "reports",
                            title: 'Report'
                        }
                    },
                    {
                        name: "qcentris-country-turnover",
                        path: "qcentris-country-turnover",
                        component: QcentrisCountryTurnover,
                        meta: {
                            parent: "reports",
                            title: 'Report'
                        }
                    }
                ]
            },
            {
                name: "qtimeReports",
                path: "qtimeReports",
                component: QtimeReports,
                redirect: {name: "qtime-activity"},
                children: [
                    {
                        name: "qtime-activity",
                        path: "qtime-activity",
                        component: QtimeActivity,
                        meta: {
                            parent: "reports",
                            title: 'Report'
                        }
                    },
                    {
                        name: "personal-overview",
                        path: "personal-overview",
                        component: PersonalOverview,
                        meta: {
                            parent: "reports",
                            title: 'Report'
                        }
                    },
                    {
                        name: "finance-report",
                        path: "finance-report",
                        component: FinanceReport,
                        meta: {
                            parent: "reports",
                            title: 'Report'
                        }
                    },
                    {
                        name: "location-overview",
                        path: "location-overview",
                        component: LocationOverview,
                        meta: {
                            parent: "reports",
                            title: 'Report'
                        }
                    },
                    {
                        name: "team-overview",
                        path: "team-overview",
                        component: TeamOverview,
                        meta: {
                            parent: "reports",
                            title: 'Report'
                        }
                    },
                    {
                        name: "release-employee-month",
                        path: "release-employee-month",
                        component: ReleaseEmployeeMonthData,
                        meta: {
                            parent: "reports",
                            title: 'Report'
                        }
                    }, 
                    {
                        name: "release-overview",
                        path: "release-overview",
                        component: ReleaseOverview,
                        meta: {
                            parent: "reports",
                            title: 'Report'
                        }
                    },
                    {
                        name: "release-overview-manager",
                        path: "release-overview-manager",
                        component: ReleaseOverviewManager,
                        meta: {
                            parent: "reports",
                            title: 'Report'
                        }
                    },
                    {
                        name: "export-employees-data",
                        path: "export-employees-data",
                        component: ExportEmployeesData,
                        meta: {
                            parent: "reports",
                            title: 'Report'
                        }
                    },
                    {
                        name: "employee-overview",
                        path: "employee-overview",
                        component: EmployeeOverview,
                        meta: {
                            parent: "reports",
                            title: 'Report'
                        }
                    },
                    {
                        name: "vacation-report-overview",
                        path: "vacation-report-overview",
                        component: VacationReportOverview,
                        meta: {
                            parent: "reports",
                            title: 'Report'
                        }
                    },
                    {
                        name: "employee-time-overview",
                        path: "employee-time-overview",
                        component: EmployeeSummary,
                        meta: {
                            parent: "reports",
                            title: 'Report'
                        }
                    },
                    // {
                    //     name: "delivery-manager-employee",
                    //     path: "delivery-manager-employee",
                    //     component: DeliveryManagerEmployeeOverview,
                    //     meta: {
                    //         parent: "reports",
                    //         title: 'Report'
                    //     }
                    // },
                    // {
                    //     name: "delivery-manager-internal",
                    //     path: "delivery-manager-internal",
                    //     component: DeliveryManagerInternalOverview,
                    //     meta: {
                    //         parent: "reports",
                    //         title: 'Report'
                    //     }
                    // },
                    // {
                    //     name: "delivery-manager-external",
                    //     path: "delivery-manager-external",
                    //     component: DeliveryManagerExternalOverview,
                    //     meta: {
                    //         parent: "reports",
                    //         title: 'Report'
                    //     }
                    // },
                    // {
                    //     name: "direct-manager-overview",
                    //     path: "direct-manager-overview",
                    //     component: DirectManagerOverview,
                    //     meta: {
                    //         parent: "reports",
                    //         title: 'Report'
                    //     }
                    // },
                ]
            },
            {
                name: "qtime",
                path: "qtime",
                component: Qtime,
                meta: {
                    title: 'Qtime'
                }
            },
            {
                name: "leaveRequest",
                path: "leaveRequest",
                component: LeaveRequest,
                meta: {
                    title: 'LeaveRequest'
                }
            },
            {
                name: "sicknessRequest",
                path: "sicknessRequest",
                component: SicknessRequest,
                meta: {
                    title: 'SicknessRequest'
                }
            }
        ]
    },
    {
        name: "login",
        path: "/login",
        component: Login,
        meta: {
            public: true, // can access without authentication
            disableIfLoggedIn: true, // cannot access if already authenticated
            title: 'Login'
        }
    },
    {
        name: "auth-check",
        path: "/auth-check",
        component: AuthCheck,
        meta: {
            public: true, // can access without authentication
            disableIfLoggedIn: true // cannot access if already authenticated
        }
    },

    {
        name: "page-not-fount",
        path: "/*",
        component: PageNotFound
    }
];
